import { defineMessages } from 'react-intl';

export default defineMessages({
  priorityString: {
    id: 'template.priority',
    description: 'priority',
    defaultMessage: 'P',
  },
  multipleOption: {
    id: 'multipleOption',
    description: 'multiple',
    defaultMessage: 'Multiple',
  },
  notApplicable: {
    id: 'notApplicable',
    description: 'n/a',
    defaultMessage: 'n/a',
  },
});
